// ── 1) モーダル開閉ロジック ──────────────
(function () {
  const modal = document.getElementById('memberModal');
  const overlay = modal.querySelector('.member-modal__overlay');
  const closeBtn = modal.querySelector('.member-modal__close');
  const loginBtn = document.getElementById('modalLoginButton');

  function openMemberModal() {
    modal.classList.add('is-active');
  }

  function closeMemberModal() {
    modal.classList.remove('is-active');
  }

  // 背景とクローズボタンで閉じる
  [overlay, closeBtn].forEach((el) => el.addEventListener('click', closeMemberModal));

  // 「ログイン画面へ」ボタン
  const loginUrl = loginBtn.dataset.loginUrl;

  loginBtn.addEventListener('click', () => {
    window.location.href = loginUrl;
  });

  window.openMemberModal = openMemberModal;
  window.closeMemberModal = closeMemberModal;
})();

// ── 2) Checkout ボタンクリック監視 & モーダル起動 ────────
document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('button[name="checkout"]');

  buttons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const isMember = btn.dataset.isMember === 'true';
      const hasMembersOnly = btn.dataset.hasMembersOnly === 'true';

      if (hasMembersOnly && !isMember) {
        e.preventDefault();
        // 定義済みのモーダル表示関数を呼び出し
        if (typeof openMemberModal === 'function') {
          openMemberModal();
          //console.log('⭐️ openMemberModal() を呼び出しました');
        } else {
          //console.warn('⚠️ openMemberModal() が見つかりません');
        }
      }
      // else はそのままフォーム submit されます
    });
  });
});
